import { z } from 'zod';
import { MediaTypeEnum } from './media-unit-variants.js';

export const FilterOptionsResponseSchema = z.object({
  regions: z.array(z.string()),
  counties: z.array(z.string()),
  agglomerations: z.array(z.string()),
  cities: z.array(z.string()),
  formats: z.array(z.object({ code: z.string(), label: z.string() })),
  suppliers: z.array(z.object({ id: z.number(), name: z.string() })),
  lightingValues: z.array(z.string()),
  mediaTypes: z.array(MediaTypeEnum),
  /** Distinct media_units.material values (CU-86cataqt9). Optional — additive field. */
  materials: z.array(z.string()).optional(),
  /** Distinct media_units.multiformat values (CU-86cataqt9). Optional — additive field. */
  multiformats: z.array(z.string()).optional(),
  /** Active tag definitions available as a filter option (CU-86cataqt9). Optional — additive field. */
  tagOptions: z.array(z.object({ code: z.string(), label: z.string() })).optional(),
  /**
   * Selectable administrative areas (e.g. Warsaw districts), sorted by name.
   * `id` is the stringified `admin_boundaries.id`, matching the
   * `administrativeAreaIds` filter field's wire type. Optional — additive field.
   */
  administrativeAreas: z.array(z.object({ id: z.string(), name: z.string() })).optional(),
});

export type FilterOptionsResponse = z.infer<typeof FilterOptionsResponseSchema>;
